"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const AuditDisplay = ({ audits, ignoreAudit: _ignoreAudit, showAuditErrorCode, hideInfoAudits = true }) => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin', 'audits']);
    const auditMessages = [];
    const items = audits !== null && audits !== void 0 ? audits : [];
    for (let i = 0, countI = items.length; i < countI; i++) {
        const audit = items[i];
        if (audit.ignore !== true && (!hideInfoAudits || (hideInfoAudits && audit.level !== 'info'))) {
            auditMessages.push(react_1.default.createElement("p", { key: `${audit.level || 'error'}_${audit.errorCode}_${i + 1}`, className: `_audit-${audit.level || 'error'} _strong` },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: audit.level === 'info' ? free_solid_svg_icons_1.faCircleInfo : free_solid_svg_icons_1.faTriangleExclamation, className: "faIconLeft" }),
                showAuditErrorCode
                    ? audit.errorCode
                    : t(`audits:${audit.errorCode}`, { defaultValue: audit.message || audit.errorCode })));
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "admin-errors-container" }, auditMessages)));
};
exports.default = AuditDisplay;
//# sourceMappingURL=AuditDisplay.js.map